import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BackendListModel } from "src/app/models/common/list.model";
import { DomainCode } from "src/app/models/common/model";
import { ApiRoutes } from "src/app/services/apiroutes";
import { DomainCodeApiService } from "src/app/services/domain_code/domain-code-api.service";
import { RequestApiService } from "src/app/services/domain_code/request-api.service";
import { MyOrdersService } from "../../my-orders-table/my-orders-table.service";
import { RequirementAlterModel } from "./requirement-alter.model";

@Component({
    selector: 'logzy-requirement-update-form',
    templateUrl: './requirement-update-form.component.html',
    styleUrls: ['./requirement-update-form.component.scss']
})

export class RequirementUpdateFormComponent implements OnInit {
    @Input()
    getReqData;

    minValue: number = 1;
    requestId;
    requirementObj: RequirementAlterModel;
    containerSizeTypeUrl = `${ApiRoutes.ContainerMaster}container_size_type/?search=::search::`
    containerConditionList: BackendListModel<DomainCode>;

    constructor(private domainService: DomainCodeApiService,
        public requestService: RequestApiService,
        private snackBar: MatSnackBar,
        private myOrderService: MyOrdersService) { }

    ngOnInit() {
        this.requirementObj = new RequirementAlterModel();
        this.getContainerCondition();
        this.requirementObj.setRequirementPayload(this.getReqData);
    }

    getContainerCondition() {
        this.domainService.getByGroup('ContainerCondition').subscribe({
            next: response => {
                this.containerConditionList = response;
            },
            error: error => {
                console.log("condition", error);
                return error;
            }
        });
    }

    // To post new requirements
    saveRequirements() {
        if (this.requirementObj.quantity < this.minValue) {
            return;
        }

        let data = {
            ...this.requirementObj.getRequirementData(),
            request: this.getReqData.request //@TODO requirements index to be changed when implementing multiple requirements for a single request.
        }

        this.requestService.postRequestRequirements(data).subscribe({
            next: response => {
                return response;
            },
            error: error => {
                console.log(error);
                return this.catchError(error);
            }
        })
    }

    // Update existing requirements
    updateRequirements() {
        if (this.requirementObj.quantity < this.minValue) {
            return;
        }

        let data = {
            ...this.requirementObj.getRequirementData(),
            request: this.getReqData.request //@TODO requirements index to be changed when implementing multiple requirements for a single request.
        }

        let requirementId = this.getReqData.id

        this.requestService.updateRequestRequirements(requirementId, data).subscribe({
            next: response => {
                this.snackBar.open("Requirements updated successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                // this.myOrderService.getRequestDetails();
                return response;
            },
            error: error => {
                console.log(error);
                return this.catchError(error);
            }
        })
    }

    catchError(error) {
        if (error.status === 400) {
            this.requirementObj.error = { ...error.error }
            return error;
        }
        if (error.status === 403 || error.status === 401) {
            this.snackBar.open(`You are not authorized to update this request`, 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
            return error;
        }
        if (error.status === 404) {
            this.snackBar.open(error.statusText, 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
            return error;
        }
        if (error.status > 499) {
            this.snackBar.open(`Something went wrong. Please refresh the page.`, 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
            return error;
        }
    }
}